/**
 * Client-side counterpart to the backend's HtmlTextExtractor.ExtractTextWithoutBase64 —
 * strips inline base64 images and HTML markup so feedback previews (e.g. table hover
 * tooltips) don't have to render or transmit the full rich-text HTML.
 */
export function extractTextWithoutBase64(html?: string | null, maxLength?: number): string {
  if (!html) return '';

  const container = document.createElement('div');
  container.innerHTML = html;

  container.querySelectorAll('img').forEach((img) => {
    const src = img.getAttribute('src') || '';
    if (src.startsWith('data:image')) {
      img.remove();
    }
  });

  container.querySelectorAll('style').forEach((style) => style.remove());

  container.querySelectorAll('br').forEach((br) => br.replaceWith('\n'));
  container.querySelectorAll('p, div, h1, h2, h3, h4, h5, h6, li, tr').forEach((el) => {
    el.append('\n');
  });

  let text = (container.textContent || '')
    .replace(/[ \t]+/g, ' ')
    .replace(/\n{3,}/g, '\n\n')
    .trim();

  if (maxLength && text.length > maxLength) {
    text = text.slice(0, maxLength).trim() + '...';
  }

  return text;
}
